import './ai';

import 'focus-visible';
import 'billboard.js/dist/billboard.css';
import 'billboard.js/dist/theme/graph.css';
import '../styles/static.less';
import 'swiper/css/bundle';
import 'billboard.js/dist/theme/graph.min.css';
import '@eloomi/design-tokens/build/base.css';
import '@eloomi/design-tokens/build/colors.css';
import '@eloomi/design-tokens/build/spacings.css';
import '@eloomi/design-tokens/build/text-styles.css';
import '@eloomi/design-tokens/build/border-radius.css';
import '@eloomi/components/button';

import FullStory from './plugins/fullstory.plugin';
import InfiniteLoading from 'vue-infinite-loading';
import PortalVue from 'portal-vue';
import VCalendar from 'v-calendar';
import VTooltip from 'v-tooltip';
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import VueTippy from 'vue-tippy';
import commonPlugin from './common/plugins';
import router from './main/baseRouter';
import store from './main/baseStore';
import RouteStackManager from '@/plugins/route-stack.plugin';
import { enableHttpRetryMechanism } from '@/api/config';
import httpClient from '@/api/http-client';
import { enableInfiniteAuthMiddleware } from '@/authentication/controllers';
import environment, { ApiAuthTypes } from '@/environment';
import { handleEndpointError } from '@/errorHandler';
import { initializeSentry } from '@/sentry';
import '@/common/directives/custom-model';
import { assignCapacitorPlatformDataAttribute } from '@/common/services/capacitor-css';
import detectBrowser from '@/common/services/detect-browser';
import DependencyInjectorPlugin from './plugins/injector.plugin';
import { mainInjector } from '@/di/injector';
import { viewHeightCorrector } from '@/common/services/correct-view-height';
import { installPermissionsRouteGuard } from './permissions/controllers';
import { AuthenticationServiceTokens } from '@/authentication/di-tokens';
import { renderApp } from '@/render-app';
import { initPushNotifications } from '@/notifications/services/push-notifications';
import { enableDebugForNamespacesFromEnv } from '@/common/services';
import { subscribeForDeepLinkOpen } from '@/common/services/subscribe-for-deep-link-open';

enableDebugForNamespacesFromEnv();

Vue.config.productionTip = false;

/**
 * Assign platform data attribute to body tag
 */
assignCapacitorPlatformDataAttribute();

/**
 * Configure a JWT token injection, HTTP 403 error handling & route transition checks
 */
if (environment.apiAuthMode === ApiAuthTypes.token) {
    enableInfiniteAuthMiddleware(httpClient, router, mainInjector);
}

/**
 * Install user permissions route guard
 */
installPermissionsRouteGuard(mainInjector);

Vue.use(DependencyInjectorPlugin, mainInjector);
Vue.use(commonPlugin);
Vue.use(FullStory);
Vue.use(VueTippy, {
    directive: 'tippy',
    theme: 'eloomi',
    placement: 'bottom',
    onShow: options => Boolean(options.props.content),
});

Vue.use(VTooltip);
Vue.use(VueLazyload);

Vue.use(InfiniteLoading, {
    slots: {
        noMore: '',
        noResults: '',
        error: '',
    },
    system: {
        throttle: 200,
    },
});
Vue.use(VCalendar, {
    componentPrefix: 'vc',
});
Vue.use(PortalVue);
Vue.use(RouteStackManager.createPlugin(router));

initializeSentry(router);

viewHeightCorrector.init();

enableHttpRetryMechanism(httpClient);
handleEndpointError(router, store);
detectBrowser();

const platformResolutionService = mainInjector.resolve(AuthenticationServiceTokens.PlatformResolutionService);

platformResolutionService.resolvePlatform().then(isPlatformFound => {
    renderApp({ isPlatformFound });
});

subscribeForDeepLinkOpen(router, platformResolutionService);
initPushNotifications(router);
